export const AL_UPDATE_STATE = "AL_UPDATE_STATE"
export const AL_UPDATE_SELECTED_FILTERS = "AL_UPDATE_SELECTED_FILTERS"
export const AL_LIST_LOADED = "AL_LIST_LOADED"
export const AL_MORE_ITEM_LOADED = "AL_MORE_ITEM_LOADED"

